import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Col, Typography, Row} from 'antd';
import '../../App.css';
import balloonIMG from '../../assets/BannerGlobos.png'
import towersIMG from '../../assets/BannerTorres.png'

const { Text, Title } = Typography;

interface FeedbackBannerProps {
  gameCode?: 'BAR2' | 'TOW2';
}

function FeedbackBanner({ gameCode = 'BAR2' }: FeedbackBannerProps) {
  const isTowers = gameCode === 'TOW2';

  const subtitle = isTowers ? 'RESULTADOS JUEGO TORRES' : 'RESULTADOS JUEGO GLOBOS';
  const image = isTowers ? towersIMG : balloonIMG;

  return (
    <>
      <Row className='title-layout'  justify='center' gutter={24} style={{width: '100%', display: 'flex' ,flexDirection: 'row', justifyContent: 'center'}} >
          <Col sm={12}>
          <Row style={{ display: 'flex' ,flexDirection: 'row', justifyContent: 'end'}} >
              <img src={image} alt='' style={{ minHeight: '20vh', maxHeight: '35vh' }} />
            </Row>
          </Col>
          <Col sm={12}>
            <Row align='middle' gutter={24} style={{display: 'flex' , height:'100%'}}>
              <Row style={{ display: 'flex', flexDirection: 'column' }}>
              <Title level={1} style={{
                  fontSize: '4vh',
                  color: '#f5edf0'
                }}>
                Reporte Genomawork
              </Title>
              <Text style={{
                color: '#f5edf0',
                fontSize: '2vh',
              }}>
                {subtitle}
              </Text>
              </Row>
            </Row>
          </Col>
        </Row>
      </>
  )}

  export default FeedbackBanner;